import apiFetch from '../apiFetch'
export default function (token, organizedUnitList) {
  const queryParamsArray = [
    organizedUnitList ? `organizedUnit=${organizedUnitList}` : null
  ]
  const queryParams = queryParamsArray.reduce(
    (result, query, idx) => result + (query ? (result ? `&${query}` : `?${query}`) : '')
    , ''
  )
  return apiFetch({ endPoint: `salesman/userHierarchy${queryParams}`, method: 'GET', body: null, token: token })
}
